import * as React from "react";
import {Field, Label, Control, Input, Button, Checkbox} from "bloomer";
import { Container, Header, FormContainer, Switch } from "./Styles";
import { BACKEND_URI } from "../../utils/Constants";
import { Redirect } from "react-router";
import {
  isLoggedIn,
  addSessionToken,
  addRefreshToken,
  getRememberMeCookies,
  setRememberMeCookies,
  clearRememberMeCookies, REMEMBER_ME_SERIAL_ID, REMEMBER_ME_TOKEN, setGAUserConfig, getUserData
} from "../../utils/auth";
import styled from "react-emotion";

const ErrorMessage = styled("div")`
  margin-top: -25px;
  text-align: center;
  line-height: 30px;
  vertical-align: middle;
  font-size: 14px;
  color: red;
  width: 90%;
`;

const RememberMeLabel = styled("label")`
  font-size: 14px;
  cursor: pointer;
  user-select: none;
`;

class LoginForm extends React.Component {
  public props: {
    switch(value: string): void;
    updateUserContext(user: any): void;
  };

  public state = {
    email: "",
    password: "",
    rememberMe: false,
    responseError: false,
    errorMessage: "",
    loading: false
  };

  public componentDidMount() {
    const rememberMeCookies = getRememberMeCookies();
    if (rememberMeCookies) {
      this.setState({rememberMe: true});
      fetch(`${BACKEND_URI}/auth/signin`, {
        body: JSON.stringify(rememberMeCookies),
        headers: {
          "Content-Type": "application/json"
        },
        method: "POST"
      }).then((response) => {
        if (response.status === 200) {
          response.json().then((result) => {
            this.onLoggedIn(result);
          });
        } else {
          clearRememberMeCookies();
          location.reload();
        }
      }).catch(() => {
        clearRememberMeCookies();
        location.reload();
      });
    }
  }

  public handleEmailChange(event: React.FormEvent<HTMLInputElement>) {
    this.setState({
      email: event.currentTarget.value,
      errorMessage: ""
    });
  }

  public handlePasswordChange(event: React.FormEvent<HTMLInputElement>) {
    this.setState({
      password: event.currentTarget.value,
      errorMessage: ""
    });
  }

  public handleRememberMeChange(event: React.FormEvent<HTMLInputElement>) {
    this.setState({
      rememberMe: event.currentTarget.checked
    });
  }

  public updateUserContext = async () => {
    const user = await getUserData();
    this.props.updateUserContext(user);
  };

  public onLoggedIn = (data: { auth_token: string, refresh_token: string }) => {
    if (data.auth_token !== "undefined" && data.auth_token !== undefined) {

      if (data[REMEMBER_ME_SERIAL_ID] && data[REMEMBER_ME_TOKEN]) {
        setRememberMeCookies(data[REMEMBER_ME_SERIAL_ID], data[REMEMBER_ME_TOKEN]);
      } else {
        clearRememberMeCookies();
      }

      addSessionToken(data.auth_token);
      addRefreshToken(data.refresh_token);
      setGAUserConfig(data.auth_token);
      setTimeout(() => {
        this.updateUserContext();
      }, 0);
    } else {
      this.setState({ responseError: true });
      throw new Error("no token provided. authentication error");
    }

    this.setState({ loading: false });
  };

  public handleSubmit = () => {
    const { email, password } = this.state;

    if (!email && !password) {
      this.setState({errorMessage: "Please enter email and password."});
      return;
    }

    if (!email) {
      this.setState({errorMessage: "Please enter email."});
      return;
    }

    if (!password) {
      this.setState({errorMessage: "Please enter password."});
      return;
    }

    fetch(`${BACKEND_URI}/auth/signin`, {
      body: JSON.stringify({
        email,
        password,
        remember_me: this.state.rememberMe
      }),
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST"
    }).then((response) => {
      response.json().then((result) => {
        if (response.status >= 400 && response.status < 500) {
          this.setState({
            errorMessage: "Email or password is incorrect."
          });
        } else {
          this.onLoggedIn(result);
        }
      });
    }).catch(() => {
       this.setState({ loading: false });
    });
  };

  public render() {
    return (
      <Container>
        <Header>Sign In</Header>
        <FormContainer>
          <Field>
            <Label>E-mail</Label>
            <Control>
              <Input
                type="text"
                placeholder="your e-mail"
                value={this.state.email}
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                  this.handleEmailChange(e)
                }
              />
            </Control>
          </Field>

          <Field>
            <Label>Password</Label>
            <Control>
              <Input
                type="password"
                placeholder="your password"
                value={this.state.password}
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                  this.handlePasswordChange(e)
                }
              />
            </Control>
          </Field>

          <Field>
            <Control>
              <RememberMeLabel>
                <Checkbox
                  checked={this.state.rememberMe}
                  onChange={(e: React.FormEvent<HTMLInputElement>) => {
                    this.handleRememberMeChange(e);
                  }}
              />&nbsp;Remember me</RememberMeLabel>
            </Control>
          </Field>
        </FormContainer>
        {
          this.state.errorMessage && <ErrorMessage>{this.state.errorMessage}</ErrorMessage>
        }
        <Button style={{ margin: "15px" }} onClick={this.handleSubmit}>
          Submit
        </Button>
        {this.state.responseError ? (
          <span> There was an error! Please try again. </span>
        ) : (
          ""
        )}
        <div>
          or{" "}
          <Switch onClick={() => this.props.switch("signup")}>Sign Up</Switch>{" "}
          instead.
        </div>
        <div>
          <Switch onClick={() => this.props.switch("forgot")}>Forgot Password?</Switch>{" "}
        </div>
        {isLoggedIn() && <Redirect to="/models" />}
      </Container>
    );
  }
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/routes/Login/LoginForm.tsx